import { render } from "./copy-premium-wallet.vue?vue&type=template&id=05b23e4c"
import script from "./copy-premium-wallet.vue?vue&type=script&lang=js"
export * from "./copy-premium-wallet.vue?vue&type=script&lang=js"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__